import {
    GET_CONFIG_FORM25,
    GET_DATOS_IMPLICADO
    
    
} from '../types';

export default function cartaCIAReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM25:
            return { ...state, cfg_form25:action.payload }
        case GET_DATOS_IMPLICADO:
            return { ...state, datosImplicado:action.payload }
       
       
       
        default:
            return state
    }
}